import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=9d78bd7e&scoped=true"
import script from "./CompanyDetails.vue?vue&type=script&lang=js"
export * from "./CompanyDetails.vue?vue&type=script&lang=js"
import style0 from "./CompanyDetails.vue?vue&type=style&index=0&id=9d78bd7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d78bd7e",
  null
  
)

export default component.exports